import { z } from 'zod';
// Base schemas
export const EmailSchema = z.email('Invalid email format');
export const DateSchema = z.coerce.date();
export const FutureDateSchema = DateSchema.refine((date) => date > new Date(), 'Date must be in the future');
export const AddressSchema = z.object({
    line1: z.string().min(1, 'Address line 1 is required'),
    line2: z.string().optional(),
    city: z.string().min(1, 'City is required'),
    state: z.string().optional(),
    postalCode: z.string().min(1, 'Postal code is required'),
    country: z.string().optional(),
});
export * from './ApiSchemas.js';
export * from './BatchSchemas.js';
export * from './BillingSchemas.js';
export * from './BusinessAnalysisSchemas.js';
export * from './BusinessConfigurationSchemas.js';
export * from './BusinessMetricSchemas.js';
export * from './ClientAccountSchemas.js';
export * from './DocSplitterSchemas.js';
export * from './JobTypeSchemas.js';
export * from './OrganizationSchemas.js';
export * from './ProviderUserRole.js';
// Selective export from ReportDiffSchemas
export { ChildrenDiffSchema, DiffedReportRowSchema, DiffedRowGroupSchema, DiffStatusSchema, FieldDiffSchema, ReportDiffForVisualizationSchema, ReportDiffPreviewResponseSchema, ReportDiffSchema, RowDiffSchema, RowGroupDiffSchema, RowInBothSchema, RowOnlyInOneSchema, RowPropertyDifferencesSchema, VisualizationMetadataSchema, } from './ReportDiffSchemas.js';
export * from './ReportSchemas.js';
export * from './ReportSourceSchemas.js';
export * from './ReportSpecificationSchemas.js';
export * from './StorageOverlaySchemas.js';
export * from './TimesheetSchemas.js';
export * from './TrialBalanceSchemas.js';
export * from './UserSchemas.js';
//# sourceMappingURL=index.js.map